import { render, staticRenderFns } from "./GroupHome.vue?vue&type=template&id=1dd8e97a&scoped=true&"
import script from "./GroupHome.vue?vue&type=script&lang=js&"
export * from "./GroupHome.vue?vue&type=script&lang=js&"
import style0 from "./GroupHome.vue?vue&type=style&index=0&id=1dd8e97a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8e97a",
  null
  
)

component.options.__file = "GroupHome.vue"
export default component.exports